import { arrayToMap } from "../util";

const list = [
  {
    name: "徒歩",
    distanceMethodId: 0,
    ratio: 1,
  },
  {
    name: "車で",
    distanceMethodId: 1,
    ratio: 10,
  },
];

export const data = {
  list: list,
  byId: arrayToMap(list, "distanceMethodId"),
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/distanceMethod.js